<div class="px-4 pb-3.5 pt-4 sm:p-6">

  <!--
    Chart.js sizing box (Bug #234): `w-full` is Tailwind, `w-100` was BOOTSTRAP (`width:100%!important`).
    The canvas below already used the Tailwind name, so this wrapper was the only Bootstrap site here.
    `maintainAspectRatio: false` means the chart's height comes entirely from this wrapper's `h-96`.
  -->
  <div class="w-full h-96 flex justify-content-center">
    @if (timeSeriesPerformanceStore.analysisErrorState) {
      @switch (timeSeriesPerformanceStore.analysisErrorState) {
        @case (ErrorAnalysis.loading) {
          <div
            class="inline-block align-self-center h-16 w-16 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
            role="status">
          </div>
        }
        @default {
          <analytics-error-message [analysisErrorState]="timeSeriesPerformanceStore.analysisErrorState"/>
        }
      }
    }

    <canvas #eventRevenueTimeSeriesChart
            [ngClass]="{'hidden': timeSeriesPerformanceStore.analysisErrorState !== undefined}"
            class="inline-flex w-full cursor-default"></canvas>

  </div>
</div>
